define('src/views/responsive-view',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // events
    'services/events/resize-events'
], function(
    _, Backbone, Mustache, U,
    // events
    ResizeEvents
) {

    var _extend = _.extend,
        _each = _.each;

    /**
     * Backbone view that enables the view to react to resize events and
     * apply classes to the root element at specified steps.
     *
     */
    var VResponsive = Backbone.View.extend({
        className: 'tc-responsive',
        globalEvents: {
            "resize": "_lazyOnResize",
        },
        /**
         * Default size breakpoints based on bootstrap 4 grid sizes.
         * size: classes
         * The classes will be applied if the view element width is smaller
         * than the size key.
         */
        sizes: {
            544: "tc-size-xs",
            768: "tc-size-sm",
            992: "tc-size-md",
            1200: "tc-size-lg"
        },

        /**
         * Overwrite the default constructor to extends events.
         */
        constructor: function() {
            var proto = VResponsive.prototype;
            // Add the regulated functions
            _extend(this, {
                previousSize: -1,
                className: this.className + ' ' + proto.className,
                globalEvents: _extend({}, proto.globalEvents, _.result(this, 'globalEvents')),

                render: _.wrap(this.render, this.renderWrapper),

                // Throttle the pace at which resize events are handled
                _lazyOnResize: _.throttle(this._onResize, 125),

                // Debounce a last call to onResize for laggy transition messing with width.
                _delayedOnResize: _.debounce(this._onResize, 800),
            });

            this._prepareSizes();

            Backbone.View.apply(this, arguments);

        },

        _prepareSizes: function() {
            this._internalSizes = [];
            _each(this.sizes, function(value, key) {
                this._internalSizes.push({
                    size: +key,
                    className: value
                });
            }, this);

        },

        /**
         * Like the name implies, wraps the render function of a child view.
         * @param  {Function} render callback from the child.
         * @return {Object}  this view for chaining.
         */
        renderWrapper: function(render) {
            Array.prototype.shift.apply(arguments);
            this.stopListeningTo(ResizeEvents);
            this.undelegateGlobalEvents();
            this.listenTo(ResizeEvents, 'resize', this._deferredOnResize);
            render.apply(this, arguments);
            this.delegateGlobalEvents();
            this.forceResize();
            return this;
        },

        forceResize: function() {
            this.previousSize = -1;
            this._deferredOnResize();
        },

        _deferredOnResize: function(e) {
            _.defer(this._onResize.bind(this), e);
        },

        _onResize: function(e) {
            var addClasses = "",
                removeClasses = "",
                $el = this.$el,
                width = this.width = $el.width();

            // prevent recalculating if the size is the same.
            if (this.previousSize === width) return;

            this.onResize(e, width);

            _each(this._internalSizes, function(value) {
                var className = value.className;
                if (width < value.size) {
                    addClasses += " " + className;
                } else {
                    removeClasses += " " + className;
                }
            }, this);

            if (addClasses !== "") $el.addClass(addClasses);
            if (removeClasses !== "") $el.removeClass(removeClasses);

            this.previousSize = width;

            this._delayedOnResize(e);
        },

        disable: function() {
            this.stopListeningTo(ResizeEvents);
            this.undelegateGlobalEvents();
            VResponsive.__super__.disable.apply(this, arguments);
        },

        // for the child view to overide
        onResize: _.noop,
    });

    return VResponsive;
});

